import axios from "axios";
import { request } from "service";

export const history = require("history").createBrowserHistory({});

export const getAuthToken = () => {
  return typeof window !== "undefined" ? localStorage.getItem("token") : null;
};

export const uploadPetProfile = (formData) => {
  let request = axios({
    method: "post",
    url: `${process.env.REACT_APP_API_CMS_URL}/upload/image/single`,
    headers: {
      Authorization: getAuthToken(),
    },
    data: formData,
  });
  return request;
};

export function getAge(dateString) {
  var ageInMilliseconds = new Date() - new Date(dateString);
  return Math.floor(ageInMilliseconds / 1000 / 60 / 60 / 24 / 365); // convert to years
}

export const exportTableData = (
  url,
  method,
  baseUrl,
  fileName,
  params = {}
) => {
  let queryParams = { ...params };
  delete queryParams.limit;
  if (params.page) {
    delete queryParams.page;
  }
  request({
    url: url,
    method: method,
    baseUrl: baseUrl,
    responseType: "blob",
    params: {
      ...queryParams,
      export: 1,
    },
  }).then((response) => {
    if (response?.data) {
      const downloadFile = document.createElement("a");
      document.body.appendChild(downloadFile);
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      downloadFile.href = url;
      downloadFile.download = `${fileName}.xlsx`;
      downloadFile.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(downloadFile);
    }
  });
};

export const amountWithComma = (number) => {
  const num = Number(number);
  if (isNaN(num)) return num;
  return num.toLocaleString("en-IN", {
    currency: "INR",
  });
};

export const spaceNotAllowed = (event) => {
  if (event.code === "Space") event.preventDefault();
};
